export default __webpack_public_path__ + "static/delivery-4052d49809477627da94f098ec694c2d.png";